import { Component, OnDestroy, OnInit } from '@angular/core';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { UserActionItemDetailState } from 'ng2-app/modules/today/state/user-action-item-detail.state';
import { UserActionItem } from 'ng2-app/modules/today/models/userActionItem.model';
import { Select, Store } from '@ngxs/store';
import { combineLatest, filter, Observable, Subject, take, takeUntil } from 'rxjs';
import { GetDocumentCategories } from 'ng2-app/store/documents/document.actions';
import { DocumentState } from 'ng2-app/store/documents/document.state';
import { DocumentCategory } from 'lendio-borrower/models/document-category/document-category.model';
import { notNull } from 'ng2-app/modules/shared/functions/filters';
import { environment } from '../../../../../../../environments/environment';
import {  UpdateAndProcessDocument, UpdateDocument } from 'ng2-app/modules/today/state/user-action-items.action';
import { format, sub } from 'date-fns';
import { LenderUserState } from 'ng2-app/store/lender-user/lender-user/lender-user.state';
import {LenderUser} from 'ng2-app/models/dto/lender-user.model';
import { MatDialog } from '@angular/material/dialog';
import { DocumentUpdateConfirmationDialogComponent } from './document-update-confirmation-dialog/document-update-confirmation-dialog.component';

@Component({
  selector: 'app-document-review',
  templateUrl: './document-review.component.html',
  styleUrls: ['./document-review.component.scss']
})
export class DocumentReviewComponent implements OnInit, OnDestroy {

  @Select(UserActionItemDetailState.activeActionItem) activeActionItem$: Observable<UserActionItem>;
  @Select(UserActionItemDetailState.documentSaving) documentSaving$: Observable<boolean>;
  @Select(DocumentState.documentCategories) documentCategories$: Observable<DocumentCategory[]>;
  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;
  @Select(LenderUserState.hasPermission('canUseDocReviewPdfToolbar')) canUseDocReviewPdfToolbar$: Observable<boolean>;

  destroyed$ = new Subject<boolean>();
  documentUrl: string;
  monthOptions: string[] = [];
  yearsOptions: string[] = [];
  documentCategory: DocumentCategory;

  constructor(
    private store: Store,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.store.dispatch(new GetDocumentCategories());
    combineLatest([this.activeActionItem$, this.documentCategories$, this.canUseDocReviewPdfToolbar$]).pipe(
      filter(notNull),
      takeUntil(this.destroyed$)
    ).subscribe(([actionItem, documentCategories, canUseDocReviewPdfToolbar]) => {
      if (actionItem?.details) {
        const doc = actionItem.details;
        let url = `${environment.API_URL}/document/${doc.id}?stream=1&access_token=${Cookie.get('auth_token')}`;
        if(!canUseDocReviewPdfToolbar) {
          url += '#toolbar=0';
        }
        this.documentUrl = url;
        this.documentCategory = documentCategories.filter(cat => cat.id === doc.category)[0] || null;
        doc.months = doc.monthsString !== '' ? doc.monthsString?.split(',') : [];
        doc.years = doc.yearsString !== '' ? doc.yearsString?.split(',') : [];
      }
    });

    this.initDateOptions();
  }

  handleDocNameChange($event) {
    this.activeActionItem$.pipe(
      take(1)
    ).subscribe(actionItem => {
      if (actionItem.details) {
        const doc = actionItem.details,
          name = $event.target.value;
        doc.title = name;
        doc.filename = name;
      }
    });
  }

  handleDocCategoryChange({ value }) {
    this.documentCategories$.pipe(
      take(1)
    ).subscribe(documentCategories => {
      this.documentCategory = documentCategories.filter(cat => cat.id === value)[0] || this.documentCategory;
    });
  }

  updateDocument(): void {
    const dialogRef = this.dialog.open(DocumentUpdateConfirmationDialogComponent, {
      width: '401px'
    });

    dialogRef.componentInstance.confirm.pipe(
      take(1)
    ).subscribe(() => {
      dialogRef.close();
      this.activeActionItem$.pipe(
        take(1)
      ).subscribe((actionItem) => {
        this.store.dispatch( new UpdateDocument(actionItem.details, actionItem.userId) );
      });
    });
  }

  processDocument(): void {
    this.activeActionItem$.pipe(
      take(1)
    ).subscribe((actionItem) => {
      this.store.dispatch( new UpdateAndProcessDocument(actionItem.details, actionItem.userId, actionItem.borrowerId));
    });
  }

  initDateOptions(): void {
    for (let i = 0; i <= 24; i++) {
      this.monthOptions.push(format(sub(new Date(Date.now()), { months: i }), 'MMM yyyy'));
    }
    for (let i = 0; i <= 5; i++) {
      this.yearsOptions.push(format(sub(new Date(Date.now()), { years: i }), 'yyyy'));
    }
  }

  formatMonth(date: string): string {
    return date ? format(new Date(date), 'MM/yyyy') : '';
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
